const caseGeneratorNorwegian = {
  header: {
    title: "Case Innlegg Generator",
    description: "La AI hjelpe deg med å skape et engasjerende LinkedIn-innlegg basert på din case"
  },
  customerBanner: {
    working: "Du genererer nå et case-innlegg for"
  },
  input: {
    title: "Beskriv din case",
    placeholder: "Fortell om din case eller historie. Det kan være en kundecase, et spennende møte, eller en annen opplevelse du gjerne vil dele på LinkedIn..."
  },
  image: {
    title: "Vil du legge til et bilde?",
    gallery: "Velg fra bildearkiv",
    upload: "Last opp bilde",
    camera: "Ta bilde",
    remove: "Fjern bilde"
  },
  buttons: {
    generate: "Generer innlegg fra case",
    generating: "Genererer innlegg...",
    retry: "Prøv igjen",
    edit: "Rediger",
    remove: "Fjern bilde",
    addImage: "Bilde",
    save: "Lagre endringer",
    saving: "Lagrer",
    cancel: "Avbryt",
    accept: "Godta",
    fortryd: "Forkast",
    scheduling: "Planlegger...",
    schedulePost: "Planlegg innlegg"
  },
  aiPrompt: {
    placeholder: "Beskriv hvordan case-innlegget skal forbedres...",
    editing: "Redigerer",
    send: "Send"
  },
  loading: {
    generating: "Genererer et LinkedIn-innlegg basert på din case..."
  },
  messages: {
    error: "Det oppstod en feil ved generering av case-innlegg. Prøv igjen senere.",
    draftLoaded: "Ditt siste case-utkast har blitt lastet",
    fieldRequired: "Vennligst skriv inn en case-beskrivelse for å generere et innlegg",
    imageAdded: "Bilde lagt til!",
    imageRemoved: "Bilde fjernet!",
    caseGenerated: "Case-innlegg generert!",
    savedChanges: "Endringer lagret!",
    caseUpdated: "Case-innlegg oppdatert!",
    imageUploaded: "Bilde lastet opp og lagt til!",
    caseScheduled: "Case-innlegg planlagt til {formattedDate}",
    aiSelectedTime: "AI har valgt det optimale tidspunktet!",
    confirmDiscard: "Er du sikker på at du vil forkaste dette innlegget? Alle endringer vil gå tapt.",
    caseRegenerated: "Case-innlegg regenerert!"
  },
  gallery: {
    title: "Velg et bilde",
    noImages: "Du har ingen bilder i arkivet ditt.",
    goToArchive: "Gå til bildearkiv"
  },
  saveModal: {
    title: "Planlegg ditt case-innlegg",
    question: "Hvordan vil du planlegge ditt case-innlegg?",
    options: {
      weekly: {
        title: "Bruk min ukentlige plan",
        description: "Innlegget vil bli delt i henhold til din normale planlegging"
      },
      custom: {
        title: "Velg selv tidspunkt",
        description: "Velg nøyaktig når innlegget skal deles"
      },
      ai: {
        title: "La AI planlegge",
        description: "AI velger det optimale tidspunktet basert på LinkedIn-statistikk"
      }
    },
    weekly: {
      confirm: "Innlegget ditt vil bli lagt til din normale planlegging og delt etter din ukentlige plan."
    },
    custom: {
      title: "Velg dato og tidspunkt for innlegget ditt:"
    },
    buttons: {
      back: "Tilbake",
      confirm: "Bekreft",
      saving: "Lagrer..."
    },
    success: {
      weekly: "Ditt case-innlegg er lagret og planlagt for deling på LinkedIn!",
      custom: "Ditt case-innlegg er planlagt for deling på LinkedIn {date}!",
      ai: "Ditt case-innlegg er planlagt for deling på LinkedIn {date}!"
    }
  },
  weekCalendar: {
    selectDay: "Velg dag for innlegget ditt",
    selectTime: "Velg tidspunkt for {day}",
    addPost: "Legg til innlegg",
    backToDays: "Tilbake til dager",
    schedulerNote: "Disse tidspunktene er konfigurert i din Planlegger men ikke ennå opptatt av eksisterende innlegg."
  }
};

export default caseGeneratorNorwegian; 